export default {
  methods: {
    customMx() {
      this.registerShapes();

      mxMarker.addMarker("bidirectional", function(canvas) {
        return function() {
          canvas.begin();
          canvas.stroke();
        };
      });

      mxEdgeHandler.prototype.snapToTerminals = true;
    },
    registerShapes() {
      this.registerLeftPortShape();
      this.registerRightPortShape();
      this.registerInPortShape();
      this.registerTopPortShape();
      this.registerBottomPortShape();

      this.registerConnection();
      this.registerNormalContact();
      this.registerNegatedContact();
      this.registerRisingEdgeContact();
      this.registerFallingEdgeContact();
      this.registerNormalCoil();
      this.registerNegatedCoil();
      this.registerSetCoil();
      this.registerResetCoil();
      this.registerRisingEdgeCoil();
      this.registerFallingEdgeCoil();
      this.registerInitialStep();
      this.registerTransition();
      this.registerJump();
      this.registerSimultaneousDivergence();
    },
    registerLeftPortShape() {
      function mxLeftPort(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxLeftPort, mxShape);

      mxLeftPort.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxLeftPort.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, h / 2);
        c.lineTo(w, h / 2);
        c.fillAndStroke();
      };

      // mxLeftPort.prototype.constraints = [
      //   new mxConnectionConstraint(new mxPoint(0, 0.5), true),
      // ];
      mxCellRenderer.registerShape("leftPort", mxLeftPort);
    },
    registerRightPortShape() {
      function mxRightPort(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxRightPort, mxShape);

      mxRightPort.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxRightPort.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, h / 2);
        c.lineTo(w, h / 2);
        c.fillAndStroke();
      };

      // mxRightPort.prototype.constraints = [
      //   new mxConnectionConstraint(new mxPoint(0, 0.5), true),
      // ];
      mxCellRenderer.registerShape("rightPort", mxRightPort);
    },
    registerInPortShape() {
      function mxInPort(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxInPort, mxShape);

      mxInPort.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxInPort.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, h / 2);
        c.lineTo(w, h / 2);
        c.moveTo(w / 4, 0);
        c.lineTo(w / 2, h / 2);
        c.moveTo(w / 4, h);
        c.lineTo(w / 2, h / 2);
        c.fillAndStroke();
      };

      // mxInPort.prototype.constraints = [
      //   new mxConnectionConstraint(new mxPoint(0, 0.5), true),
      // ];
      mxCellRenderer.registerShape("inPort", mxInPort);
    },
    registerTopPortShape() {
      function mxTopPort(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxTopPort, mxShape);

      mxTopPort.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxTopPort.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 2, 0);
        c.lineTo(w / 2, h);
        c.fillAndStroke();
      };

      // mxTopPort.prototype.constraints = [
      //   new mxConnectionConstraint(new mxPoint(0, 0.5), true),
      // ];
      mxCellRenderer.registerShape("topPort", mxTopPort);
    },
    registerBottomPortShape() {
      function mxBottomPort(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxBottomPort, mxShape);

      mxBottomPort.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxBottomPort.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 2, 0);
        c.lineTo(w / 2, h);
        c.fillAndStroke();
      };

      // mxBottomPort.prototype.constraints = [
      //   new mxConnectionConstraint(new mxPoint(0, 0.5), true),
      // ];
      mxCellRenderer.registerShape("bottomPort", mxBottomPort);
    },
    registerConnection() {
      function mxConnection(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxConnection, mxShape);

      mxConnection.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxConnection.prototype.redrawPath = function(c, x, y, w, h) {
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.lineTo(10, h / 2);
        c.lineTo(0, h);
        c.moveTo(w - 10, 0);
        c.lineTo(w, h / 2);
        c.lineTo(w - 10, h);
        c.fillAndStroke();
      };

      mxCellRenderer.registerShape("connection", mxConnection);
    },
    registerNormalContact() {
      function mxContact(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxContact, mxShape);

      mxContact.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxContact.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, 0);
        c.lineTo(0, h);
        c.moveTo(w, 0);
        c.lineTo(w, h);
      };

      mxCellRenderer.registerShape("normalContact", mxContact);
    },
    registerNegatedContact() {
      function mxContact(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxContact, mxShape);

      mxContact.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxContact.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, 0);
        c.lineTo(0, h);
        c.moveTo(w, 0);
        c.lineTo(w, h);
        c.moveTo((w * 3) / 5, (h * 1) / 4);
        c.lineTo((w * 2) / 5, (h * 3) / 4);
      };

      mxCellRenderer.registerShape("negatedContact", mxContact);
    },
    registerRisingEdgeContact() {
      function mxContact(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxContact, mxShape);

      mxContact.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxContact.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, 0);
        c.lineTo(0, h);
        c.moveTo(w, 0);
        c.lineTo(w, h);
        c.text(w / 2, h / 2, null, null, "P", "center", "middle");
      };

      mxCellRenderer.registerShape("risingEdgeContact", mxContact);
    },
    registerFallingEdgeContact() {
      function mxContact(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxContact, mxShape);

      mxContact.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxContact.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, 0);
        c.lineTo(0, h);
        c.moveTo(w, 0);
        c.lineTo(w, h);
        c.text(w / 2, h / 2, null, null, "N", "center", "middle");
      };

      mxCellRenderer.registerShape("fallingEdgeContact", mxContact);
    },
    registerNormalCoil() {
      function mxCoil(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxCoil, mxShape);

      mxCoil.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxCoil.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 10, 0);
        c.curveTo(0, h / 4, 0, (3 * h) / 4, w / 10, h);
        c.moveTo((9 * w) / 10, 0);
        c.curveTo(w, h / 4, w, (3 * h) / 4, (9 * w) / 10, h);
      };

      mxCellRenderer.registerShape("normalCoil", mxCoil);
    },
    registerNegatedCoil() {
      function mxCoil(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxCoil, mxShape);

      mxCoil.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxCoil.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 10, 0);
        c.curveTo(0, h / 4, 0, (3 * h) / 4, w / 10, h);
        c.moveTo((9 * w) / 10, 0);
        c.curveTo(w, h / 4, w, (3 * h) / 4, (9 * w) / 10, h);
        c.moveTo((w * 3) / 5, (h * 1) / 4);
        c.lineTo((w * 2) / 5, (h * 3) / 4);
      };

      mxCellRenderer.registerShape("negatedCoil", mxCoil);
    },
    registerSetCoil() {
      function mxCoil(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxCoil, mxShape);

      mxCoil.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxCoil.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 10, 0);
        c.curveTo(0, h / 4, 0, (3 * h) / 4, w / 10, h);
        c.moveTo((9 * w) / 10, 0);
        c.curveTo(w, h / 4, w, (3 * h) / 4, (9 * w) / 10, h);
        c.text(w / 2, h / 2, null, null, "S", "center", "middle");
      };

      mxCellRenderer.registerShape("setCoil", mxCoil);
    },
    registerResetCoil() {
      function mxCoil(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxCoil, mxShape);

      mxCoil.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxCoil.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 10, 0);
        c.curveTo(0, h / 4, 0, (3 * h) / 4, w / 10, h);
        c.moveTo((9 * w) / 10, 0);
        c.curveTo(w, h / 4, w, (3 * h) / 4, (9 * w) / 10, h);
        c.text(w / 2, h / 2, null, null, "R", "center", "middle");
      };

      mxCellRenderer.registerShape("resetCoil", mxCoil);
    },
    registerRisingEdgeCoil() {
      function mxCoil(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxCoil, mxShape);

      mxCoil.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxCoil.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 10, 0);
        c.curveTo(0, h / 4, 0, (3 * h) / 4, w / 10, h);
        c.moveTo((9 * w) / 10, 0);
        c.curveTo(w, h / 4, w, (3 * h) / 4, (9 * w) / 10, h);
        c.text(w / 2, h / 2, null, null, "P", "center", "middle");
      };

      mxCellRenderer.registerShape("risingEdgeCoil", mxCoil);
    },
    registerFallingEdgeCoil() {
      function mxCoil(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxCoil, mxShape);

      mxCoil.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxCoil.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 10, 0);
        c.curveTo(0, h / 4, 0, (3 * h) / 4, w / 10, h);
        c.moveTo((9 * w) / 10, 0);
        c.curveTo(w, h / 4, w, (3 * h) / 4, (9 * w) / 10, h);
        c.text(w / 2, h / 2, null, null, "N", "center", "middle");
      };

      mxCellRenderer.registerShape("fallingEdgeCoil", mxCoil);
    },
    registerInitialStep() {
      function mxInitialStep(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxInitialStep, mxShape);

      mxInitialStep.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxInitialStep.prototype.redrawPath = function(c, x, y, w, h) {
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);

        c.moveTo(3, 3);
        c.lineTo(w - 3, 3);
        c.lineTo(w - 3, h - 3);
        c.lineTo(3, h - 3);
        c.lineTo(3, 3);
        c.fillAndStroke();
      };

      mxCellRenderer.registerShape("initialStep", mxInitialStep);
    },
    registerTransition() {
      function mxTransition(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxTransition, mxShape);

      mxTransition.prototype.paintVertexShape = function(c, x, y, w, h) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxTransition.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(w / 2, 0);
        c.lineTo(w / 2, h);
        c.moveTo(0, h / 2);
        c.lineTo(w, h / 2);
      };

      mxCellRenderer.registerShape("transition", mxTransition);
    },
    registerJump() {
      function mxJump(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxJump, mxShape);

      mxJump.prototype.paintVertexShape = function(
        c,
        x,
        y,
        w,
        h
      ) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxJump.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.setFillColor("black");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w/2, h);
        c.lineTo(0, 0);
      };

      mxCellRenderer.registerShape(
        "jump",
        mxJump
      );
    },
    registerSimultaneousDivergence() {
      function mxSimultaneousDivergence(bounds, fill, stroke, strokewidth) {
        mxShape.call(this);
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokewidth = strokewidth != null ? strokewidth : 1;
      }

      mxUtils.extend(mxSimultaneousDivergence, mxShape);

      mxSimultaneousDivergence.prototype.paintVertexShape = function(
        c,
        x,
        y,
        w,
        h
      ) {
        c.translate(x, y);
        c.begin();
        this.redrawPath(c, x, y, w, h);
        c.fillAndStroke();
      };

      mxSimultaneousDivergence.prototype.redrawPath = function(c, x, y, w, h) {
        c.setStrokeColor("#ffffff");
        c.setFillColor("#ffffff");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.lineTo(w, h);
        c.lineTo(0, h);
        c.lineTo(0, 0);
        c.fillAndStroke();

        c.begin();
        c.setStrokeColor("black");
        c.moveTo(0, 0);
        c.lineTo(w, 0);
        c.moveTo(0, 3);
        c.lineTo(w, 3);
      };

      mxCellRenderer.registerShape(
        "simultaneousDivergence",
        mxSimultaneousDivergence
      );
    },
  },
};
